import { useCrmHub, type HubStatus } from '@/context/SignalRContext'

export function hubStatusLabel(status: HubStatus) {
  if (status === 'connected') return 'Live'
  if (status === 'connecting' || status === 'reconnecting') return 'Reconnecting'
  if (status === 'disconnected') return 'Offline'
  return 'Offline'
}

export function HubStatusPill() {
  const { status, reconnect } = useCrmHub()
  const label = hubStatusLabel(status)
  const live = status === 'connected'
  const busy = status === 'connecting' || status === 'reconnecting'
  return (
    <button
      type="button"
      className={`header-connection-pill${live ? '' : ' header-connection-pill--offline'}${busy ? ' header-connection-pill--busy' : ''}`}
      title={live ? 'Live connection to CRM updates' : busy ? 'Trying to reconnect to CRM updates' : 'Offline from CRM updates. Click to retry.'}
      aria-label={live ? 'SignalR live' : busy ? 'Reconnecting to SignalR' : 'SignalR offline, click to reconnect'}
      disabled={live || busy}
      onClick={() => reconnect()}
    >
      <span className="header-connection-pill__dot" />
      <span className="header-connection-pill__label">{label}</span>
    </button>
  )
}
